/* eslint-disable no-undef */
import React, { useEffect, useState, Fragment } from 'react';
import { useSelector } from 'react-redux';

import { SPECTRUM } from 'constants/predicates';
import { loadEnum } from 'actions/fieldActions';
import { valueToOption, optionToValue } from 'helpers/objectHelpers';
import Select from 'react-select';
import Required from 'field/common/Required';
import Header from 'field/common/Header';

// SPEC-41
// disable selection if isParentCollection = true
const ParentCollectionEdit = ({ field }) => {
  const [parentOptions, setParentOptions] = useState([]);
  const parentCollectionChecked = useSelector(state => 
    state.field.fields[SPECTRUM.IS_PARENT_COLLECTION]?.values[0] === true
  )
  const specialCollectionChecked = useSelector(state => 
    state.field.fields[SPECTRUM.IS_SPECIAL_COLLECTION]?.values[0] === true
  )
  
  useEffect(() => {
    loadEnum(field.predicate).then(res => setParentOptions(res.options));
  }, []);

  useEffect(() => {
    field.setDisabled((parentCollectionChecked || specialCollectionChecked));
    field.setRequired((!parentCollectionChecked && !specialCollectionChecked));
  }, [parentCollectionChecked, specialCollectionChecked]);

  return (
    <Fragment>
      <Header field={field} />
      <Select
        isDisabled={field.disabled}
        options={parentOptions}
        value={valueToOption(field.values[0])}
        onChange={option => field.setValue(0, optionToValue(option))}
      />
      {
        !field.disabled 
          && <Required minOccurs={1} valueCount={field.values.length} />
      }
    </Fragment>
  );
};

export default ParentCollectionEdit;